import { Bell, Bot, Building2, Feather, LifeBuoy, ListChecks, Search, Send, TrendingUp, type LucideIcon } from "lucide-react"
import type { WorkspaceId } from "@/lib/workspaces"
import { cn } from "@/lib/utils"

/** Icon and tint per workspace. Studio and Outreach keep the colors their sidebar pills had. */
const WORKSPACE_LOOK: Record<WorkspaceId, { icon: LucideIcon; tile: string }> = {
  seo: { icon: Search, tile: "bg-[#2450b826] text-[#2450b8] dark:bg-[#7ea6ea2e] dark:text-[#7ea6ea]" },
  studio: { icon: Feather, tile: "bg-[#e5484d24] text-[#c62a5f] dark:bg-rose-500/20 dark:text-rose-300" },
  outreach: { icon: Send, tile: "bg-[#00a2a324] text-[#007c80] dark:bg-teal-500/20 dark:text-teal-300" },
  tasks: { icon: ListChecks, tile: "bg-muted text-foreground" },
  events: { icon: Bell, tile: "bg-[#f5a5242e] text-[#a1580b] dark:bg-amber-500/20 dark:text-amber-300" },
  agency: { icon: Building2, tile: "bg-[#5746af26] text-[#5746af] dark:bg-violet-500/20 dark:text-violet-300" },
  products: { icon: TrendingUp, tile: "bg-[#008ff519] text-[#006dcbf2] dark:bg-[#0077ff3a] dark:text-[#70b8ff]" },
  support: { icon: LifeBuoy, tile: "bg-[#e5484d1a] text-[#ce2c31] dark:bg-[#ff173f2d] dark:text-[#ff9592]" },
  agents: { icon: Bot, tile: "bg-[#00a43319] text-[#00713fde] dark:bg-emerald-500/20 dark:text-emerald-300" },
}

/** The workspace's square icon: 24px in the menu, 32px on the switcher button, 56px on the switch card. */
export function WorkspaceTile({ id, size = "sm" }: { id: WorkspaceId; size?: "sm" | "md" | "lg" }) {
  const { icon: Icon, tile } = WORKSPACE_LOOK[id]
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center",
        size === "lg" ? "h-14 w-14 rounded-2xl" : size === "md" ? "h-8 w-8 rounded-lg" : "h-6 w-6 rounded-md",
        tile
      )}
    >
      <Icon strokeWidth={2.5} className={size === "lg" ? "h-7 w-7" : size === "md" ? "h-[18px] w-[18px]" : "h-3.5 w-3.5"} />
    </span>
  )
}
